import React, { SyntheticEvent } from 'react'
import { useState } from 'react'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import { Box, Tab } from '@mui/material'
import InfoBlock from '../../components/InfoBlock'
import { PRTable, PRTableProps } from './PRTable'
import PRInputsApi from '../../../api/PRInputsApi'
import { PRInputEntity } from 'types/PRInput'
import { CompanyEntity } from 'types/CompanyEntity'

export const PRTabs = ({
    prsInInbox,
    prsArchived,
    setPrsInInbox,
    setPrsArchived,
    setSelectedCompany,
    selectedPR,
    setSelectedPR,
    onArchive,
    ...prTableProps
}: {
    prsInInbox: PRInputEntity[] | null
    prsArchived: PRInputEntity[] | null
    setPrsInInbox: (prs: PRInputEntity[]) => void
    setPrsArchived: (prs: PRInputEntity[]) => void
    setSelectedCompany: (c: Pick<CompanyEntity, 'id' | 'name'>) => void
    selectedPR: PRInputEntity | null
    setSelectedPR: (pr: PRInputEntity | null) => void
} & Omit<PRTableProps, 'onBlock' | 'prs'>) => {
    const [selectedTab, setSelectedTab] = useState<'inbox' | 'archived'>('inbox')
    const handleChange = (event: SyntheticEvent, newValue: 'inbox' | 'archived') => setSelectedTab(newValue)
    const prinputsApi = new PRInputsApi()

    const handleUnarchive = (pr: PRInputEntity) => {
        pr.archived = null
        prinputsApi
            .unArchive(pr)
            .then(() => console.log(`Unarchived ${pr.url}`))
            .catch((error) => console.error(error))

        if (prsArchived) {
            setPrsArchived([...prsArchived.toSpliced(prsArchived.indexOf(pr), 1)])
        }

        setPrsInInbox([pr, ...(prsInInbox ?? [])])
    }

    const handleBlock = async (pr: PRInputEntity) => {
        await prinputsApi.block(pr)

        if (prsInInbox) {
            setPrsInInbox([...prsInInbox.toSpliced(prsInInbox.indexOf(pr), 1)])
        }

        setPrsArchived([pr, ...(prsArchived ?? [])])
        // TODO: remove (archive) other PRs matching the same path
    }

    return (
        <InfoBlock title='Pressmeddelanden' loadingElement={!prsInInbox && !prsArchived}>
            <TabContext value={selectedTab}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleChange}>
                        <Tab label='Inbox' value='inbox' />
                        <Tab label='Arkiverade' value='archived' />
                    </TabList>
                </Box>
                <TabPanel value='inbox'>
                    <PRTable
                        prs={prsInInbox}
                        onArchive={onArchive}
                        onBlock={handleBlock}
                        {...prTableProps}
                        setSelectedCompany={setSelectedCompany}
                        selectedPR={selectedPR}
                        setSelectedPR={setSelectedPR}
                    />
                </TabPanel>
                <TabPanel value='archived'>
                    <PRTable prs={prsArchived} onUnarchive={handleUnarchive} {...prTableProps} />
                </TabPanel>
            </TabContext>
        </InfoBlock>
    )
}
